// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"322737db","453":"af5d2e65"}[chunkId] + ".chunk.js";
};